import { useStores } from '@src/Common/Hooks/useStores';
import DropdownAutocomplete from '@src/Components/Atoms/DropdownAutocomplete/DropdownAutocomplete';
import React from 'react';
import { DropdownCountryProps } from './DropdownCountry.type';

const DropdownCountry: React.FC<DropdownCountryProps> = ({
  defaultValue,
  onChange,
  disabled = false
}) => {
  const { CountryStore } = useStores();

  return (
    <DropdownAutocomplete
      dataTestId="dropdown-country"
      list={
        CountryStore.countries.map((v) => ({
          label: v.name,
          value: v.name
        })) ?? []
      }
      onChange={onChange}
      size={'small'}
      placeholder="All Country"
      maxTagCount={4}
      defaultValue={defaultValue}
      disabled={disabled}
    />
  );
};

export default DropdownCountry;
